import { ConfigService } from "../basic/config.service";
import { RequestClientService } from "../basic/request-client.service";
import { autoinject } from "aurelia-framework";
import type { CreateOrderRequest, CreateOrderResponsse, GetCustomerSubscriptionResponse,
     GetCustomerSubscriptionVesselsResponse, PurchaseProductResponse, RightStoreCheckoutProductInformationModel, 
     RightStoreCheckoutPurchaseModel } from "../../models/rightstore/rightstore.models";

@autoinject()
export class RightStoreService {
    
    private rightStoreBaseUrl;

    constructor(private requestClient: RequestClientService, private configService: ConfigService) {
        this.rightStoreBaseUrl = this.configService.config.urls.rightStoreApiUrl;
    }

    public getCustomerSubscription(customerId: number, productCode: string) : Promise<GetCustomerSubscriptionResponse> {
        return this.requestClient.post<GetCustomerSubscriptionResponse>(`${this.rightStoreBaseUrl}/api/CustomerSubscriptionAuth/GetCustomerSubscription`, {}, { customerId: customerId, productCode: productCode })
    }

    public createOrUpdateOrder(request: CreateOrderRequest) : Promise<CreateOrderResponsse> {
        return this.requestClient.post<CreateOrderResponsse>(`${this.rightStoreBaseUrl}/api/Order/CreateOrder`, {}, request)
    }

    public getCustomerSubscriptionVessels(customerSubscriptionId: number) : Promise<GetCustomerSubscriptionVesselsResponse> {
        return this.requestClient.post<GetCustomerSubscriptionVesselsResponse>(`${this.rightStoreBaseUrl}/api/CustomerSubscriptionAuth/GetCustomerSubscriptionVessels`, {}, { customerSubscriptionId: customerSubscriptionId })
    }

    public requestProductInformation(customerNumber: number, productNumber: string, userName: string, quantity: number): Promise<RightStoreCheckoutProductInformationModel> {
        return this.requestClient.get(`${this.rightStoreBaseUrl}/api/product/RequestProductInformation`, { customerNumber, productNumber, userName, quantity })
    }

    public purchaseProduct(model: RightStoreCheckoutPurchaseModel): Promise<PurchaseProductResponse> {
        return this.requestClient.post(`${this.rightStoreBaseUrl}/api/product/PurchaseProduct`, {}, { 
            productNumber: model.productNumber, 
            customerNumber: model.customerNumber, 
            userName: model.userName, 
            quantity: model.checkoutQuantity, 
            paymentMethod: model.paymentMethod, 
            queryParams: model.queryParams 
        });
    }
}